import { render } from "./WDataTableEmptyRow.vue?vue&type=template&id=5a0d02fc"
const script = {}

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__